export default __webpack_public_path__ + "static/media/illustration.52d275da.jpg";